/** UI geo value: ISO country, or `AU:VIC`-style country + region. */

const GEO_SEP = ':';

export function apiCountryCode(selection: string): string {
  if (!selection) return '';
  return selection.split(GEO_SEP)[0] ?? '';
}

export function geoRegionCode(selection: string): string {
  const parts = selection.split(GEO_SEP);
  return parts.length > 1 ? (parts[1] ?? '') : '';
}

export function encodeGeo(country: string, region?: string): string {
  if (!country) return '';
  if (!region) return country;
  return `${country}${GEO_SEP}${region}`;
}
